import {createContext, type ReactNode, useContext} from 'react';

export type EasyFormsColorScheme = 'light' | 'dark';

const FormColorSchemeContext = createContext<EasyFormsColorScheme>('light');

export function FormColorSchemeProvider({
  children,
  scheme,
}: {
  children: ReactNode;
  scheme: EasyFormsColorScheme;
}) {
  return (
    <FormColorSchemeContext.Provider value={scheme}>
      {children}
    </FormColorSchemeContext.Provider>
  );
}

export function useFormColorScheme(): EasyFormsColorScheme {
  return useContext(FormColorSchemeContext);
}
